import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
const Error404 = () =>
  import(/* webpackChunkName: "din-error" */ './views/Error404.vue')
const Agreement = () =>
  import(/* webpackChunkName: "din-agreement" */ './views/Agreement.vue')
const Enterprise = () =>
  import(/* webpackChunkName: "din-engerprise" */ './views/Enterprise.vue')
const Job = () => import(/* webpackChunkName: "din-job" */ './views/Job.vue')
const About = () =>
  import(/* webpackChunkName: "din-about" */ './views/About.vue')
const Finder = () =>
  import(/* webpackChunkName: "din-finder" */ './views/Finder.vue')
const Depot = () =>
  import(/* webpackChunkName: "din-depot" */ './views/Depot.vue')
const LearningPath = () =>
  import(/* webpackChunkName: "din-learningpath" */ './views/LearningPath.vue')
//日签
const Calendar = () =>
  import(/* webpackChunkName: "din-calendar" */ './views/Calendar.vue')
//生成日签
const CustomCalendar = () =>
  import(/* webpackChunkName: "din-calendar" */ './views/CustomCalendar.vue')
//测试
const Test = () =>
  import(/* webpackChunkName: "din-learningpath" */ './views/Test.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement,
    },
    {
      path: '/enterprise',
      name: 'enterprise',
      component: Enterprise,
    },
    {
      path: '/job',
      name: 'job',
      component: Job,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/finder',
      name: 'finder',
      component: Finder,
    },
    {
      path: '/depot',
      name: 'depot',
      component: Depot,
    },
    {
      path: '/learningpath',
      name: 'learningpath',
      component: LearningPath,
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
    },
    {
      path: '/customCalendar',
      name: 'customCalendar',
      component: CustomCalendar,
    },
    {
      path: '/404',
      name: 'error404',
      component: Error404,
    },
    {
      path: '/test',
      name: 'test',
      component: Test,
    },
  ],
})
